import PropTypes from 'prop-types';
import { useState, useRef, useEffect, useCallback } from 'react';
// shadcn
import { Button } from 'src/@/components/ui/button';
import { LoadingButton } from 'src/@/components/ui/loading-button';
import { Input } from 'src/@/components/ui/input';
import { Label } from 'src/@/components/ui/label';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from 'src/@/components/ui/card';
import { Badge } from 'src/@/components/ui/badge';
import { Separator } from 'src/@/components/ui/separator';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from 'src/@/components/ui/dialog';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/@/components/ui/tooltip';
import { Popover, PopoverContent, PopoverTrigger } from 'src/@/components/ui/popover';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from 'src/@/components/ui/command';
import { ScrollArea } from 'src/@/components/ui/scroll-area';
import { Calendar } from 'src/@/components/ui/calendar';
import { cn } from 'src/@/lib/utils';
import { Check, ChevronsUpDown, CalendarIcon, Trash2 } from 'lucide-react';
import { Checkbox } from 'src/@/components/ui/checkbox';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
// hooks
import useResponsive from 'src/hooks/useResponsive';
// components
import Iconify from 'src/components/Iconify';
import Scrollbar from 'src/components/Scrollbar';
//
import KanbanTaskCommentList from './KanbanTaskCommentList';
import ChamadosArquivos from './ChamadosArquivos'
import KanbanTaskCommentInput from './KanbanTaskCommentInput';

//icons
import { BsFillXOctagonFill } from "react-icons/bs";

import { getVerChamado, getListaTickets, getRefreshComments, getListaColunas, changeOpenDetalhesChamado } from 'src/redux/slices/chamados';
import { useDispatch, useSelector } from 'react-redux';

import ModalConfimacao from 'src/components/modal/ModalConfimacao';
import TimelinePadrao from 'src/components/chamados/TimelinePadrao';
import Editor from './ChamadosNovoChamado/editor';
import useAuth from 'src/hooks/useAuth';
import Markdown from 'src/components/Markdown';
import InputStyle from 'src/components/InputStyle';

/// actions
import actionListaInputsPrioridade from 'src/actions/chamados/actionListaInputsPrioridade';
import v2_actionUploadS3 from 'src/actions/v2/global/actionUploadS3';
import getActionListaUsuariosByClienteId from 'src/actions/usuarios/getActionListaUsuariosByClienteId';
import actionCriarComentario from 'src/actions/chamados/comentarios/actionCriarComentario';
import actionEditarChamado from 'src/actions/chamados/actionEditarChamado';
import actionBuscarChatsParaVincular from 'src/actions/chamados/actionBuscarChatsParaVincular';
import { ChatWindow } from 'src/sections/@chats/chat';
import {
    getChatInfoByChatId,
    getMensagensWhatsappDb,
} from 'src/redux/slices/chat';


import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "src/@/components/ui/tabs"
import { Textarea } from "src/@/components/ui/textarea"
import { Avatar, AvatarFallback, AvatarImage } from 'src/@/components/ui/avatar';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'src/@/components/ui/select';
import {
  Plus, Search, MessageSquare, ArrowLeft, Send, Clock,
  CheckCircle2, AlertCircle, FileText, Bug, BookOpen, CheckSquare,
  MoreHorizontal, User, Tag, Calendar as CalendarLucide, Paperclip, Link as LinkIcon, Share2,
  MessagesSquare
} from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';

// DateTimePicker customizado
function DateTimePicker({ value, onChange, disabled, label, ...props }) {
  const [date, setDate] = useState(value || new Date());
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (value) {
      setDate(value);
    }
  }, [value]);

  const handleDateSelect = (selectedDate) => {
    if (selectedDate) {
      const newDate = new Date(selectedDate);
      newDate.setHours(date.getHours());
      newDate.setMinutes(date.getMinutes());
      setDate(newDate);
      if (onChange) {
        onChange(newDate);
      }
    }
  };

  const handleTimeChange = (type, val) => {
    const newDate = new Date(date);
    if (type === "hour") {
      newDate.setHours(parseInt(val));
    } else if (type === "minute") {
      newDate.setMinutes(parseInt(val));
    }
    setDate(newDate);
    if (onChange) {
      onChange(newDate);
    }
  };

  const hours = Array.from({ length: 24 }, (_, i) => i);
  const minutes = Array.from({ length: 12 }, (_, i) => i * 5);

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <button
          disabled={disabled}
          className={cn(
            "flex items-center gap-1 text-[13px] text-gray-900 dark:text-gray-100 hover:text-violet-600 dark:hover:text-violet-400 transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed",
            !date && "text-gray-400 dark:text-gray-500"
          )}
        >
          {date ? (
            format(date, "dd MMM yyyy, HH:mm", { locale: ptBR })
          ) : (
            <span className="text-gray-400 hover:text-violet-500 transition-colors">+ Adicionar</span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent onOpenAutoFocus={(e) => e.preventDefault()} className="w-auto p-0 rounded-xl shadow-lg border-gray-200">
        <div className="flex">
          <Calendar
            locale={ptBR}
            mode="single"
            selected={date}
            onSelect={handleDateSelect}
            initialFocus
            className="rounded-l-xl"
          />
          <div className="flex flex-col border-l border-gray-100 p-2 bg-gray-50/50">
            <ScrollArea className="h-[200px] w-20">
              <div className="flex flex-col gap-1">
                {hours.map((hour) => (
                  <Button
                    key={hour}
                    size="sm"
                    variant={date && date.getHours() === hour ? "default" : "ghost"}
                    className={cn(
                      "h-8 w-full text-xs rounded-lg",
                      date && date.getHours() === hour ? "bg-[#7C3AED] hover:bg-[#6d28d9]" : ""
                    )}
                    onClick={() => handleTimeChange("hour", hour.toString())}
                  >
                    {hour.toString().padStart(2, '0')}
                  </Button>
                ))}
              </div>
            </ScrollArea>
            <ScrollArea className="h-[200px] w-20 border-t border-gray-100 mt-2 pt-2">
              <div className="flex flex-col gap-1">
                {minutes.map((minute) => (
                  <Button
                    key={minute}
                    size="sm"
                    variant={date && date.getMinutes() === minute ? "default" : "ghost"}
                    className={cn(
                      "h-8 w-full text-xs rounded-lg",
                      date && date.getMinutes() === minute ? "bg-[#7C3AED] hover:bg-[#6d28d9]" : ""
                    )}
                    onClick={() => handleTimeChange("minute", minute.toString())}
                  >
                    {minute.toString().padStart(2, '0')}
                  </Button>
                ))}
              </div>
            </ScrollArea>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
}

// Componente Combobox para substituir Autocomplete
function Combobox({ options = [], value, onChange, getOptionLabel, placeholder, className, multiple = false, disabled = false, onOpen, ...props }) {
  const [open, setOpen] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  const filteredOptions = options.filter(option => {
    const label = getOptionLabel(option);
    return label && typeof label === 'string' && label.toLowerCase().includes(searchValue.toLowerCase());
  });

  const handleSelect = (option) => {
    if (multiple) {
      const currentValues = Array.isArray(value) ? value : [];
      const isSelected = currentValues.some(v => getOptionLabel(v) === getOptionLabel(option));
      if (isSelected) {
        onChange(currentValues.filter(v => getOptionLabel(v) !== getOptionLabel(option)));
      } else {
        onChange([...currentValues, option]);
      }
    } else {
      if (onChange) {
        onChange(option);
      }
      setOpen(false);
    }
  };

  const displayValue = multiple
    ? value && value.length > 0
      ? value.map(v => getOptionLabel(v)).join(', ')
      : placeholder || 'Selecionar'
    : value
      ? getOptionLabel(value)
      : placeholder || 'Selecionar';

  return (
    <Popover open={open} onOpenChange={(open) => {
      setOpen(open);
      if (open && onOpen) {
        onOpen();
      }
    }}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          disabled={disabled}
          className={cn(
            "w-full justify-between h-10 text-sm rounded-xl bg-[#F9FAFB] border-gray-200 hover:border-gray-300 hover:bg-white transition-all shadow-sm",
            className
          )}
          {...props}
        >
          <span className="truncate">{displayValue}</span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[var(--radix-popover-trigger-width)] p-0 rounded-xl shadow-lg border-gray-200 z-[9999] bg-white" align="start">
        <Command shouldFilter={false} className="rounded-xl">
          <CommandInput
            placeholder="Pesquisar..."
            value={searchValue}
            onValueChange={setSearchValue}
            className="text-xs h-9"
          />
          <CommandList className="max-h-[200px] overflow-y-auto">
            <CommandEmpty className="text-xs py-2 text-center text-gray-500">Nenhum resultado encontrado.</CommandEmpty>
            <CommandGroup>
              {filteredOptions.length > 0 && filteredOptions.map((option, index) => {
                const isSelected = multiple
                  ? value && value.some(v => getOptionLabel(v) === getOptionLabel(option))
                  : value && getOptionLabel(value) === getOptionLabel(option);
                return (
                  <CommandItem
                    key={option._id || index}
                    value={getOptionLabel(option)}
                    onSelect={() => handleSelect(option)}
                    className="cursor-pointer text-xs py-2 text-gray-700 aria-selected:bg-[#7C3AED]/10 aria-selected:text-[#7C3AED]"
                  >
                    <Check
                      className={cn(
                        "mr-2 h-4 w-4",
                        isSelected ? "opacity-100 text-[#7C3AED]" : "opacity-0"
                      )}
                    />
                    {getOptionLabel(option)}
                  </CommandItem>
                );
              })}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}

// ----------------------------------------------------------------------


ChamadosDetalhes.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  chamado: PropTypes.object,
  comentarios: PropTypes.array
};

export default function ChamadosDetalhes({
  chamado,
  comentarios,
  isOpen,
  onClose,
  isDialog = true,
}) {
  const isDesktop = useResponsive('up', 'sm');
  const dispatch = useDispatch()
  const { user } = useAuth();
  const [openConfirmaFinalizacao, setOpenConfirmaFinalizacao] = useState(false);
  const [openConfirmaExlusaoArquivos, setOpenConfirmaExlusaoArquivos] = useState(false);

  // files
  const [files, setFiles] = useState([]);
  const filesUrl = []
  const [filesEdit, setFilesEdit] = useState([]);
  const [preview, setPreview] = useState(true);
  const [isFile, setIsFile] = useState(false);
  const [loadingEnviarArquivos, setLoadingEnviarArquivos] = useState(false);

  const [isEdit, setIsEdit] = useState(false);
  const [isEditFile, setIsEditFile] = useState(true);
  const [attachments, setAttachments] = useState([]);
  const [prioridade2, setPrioridade] = useState(chamado && chamado.prioridade);
  const [completado, setCompletado] = useState(chamado && chamado.completado)
  const [titulo, setTitulo] = useState(chamado && chamado.titulo);
  const [chamadoId, setChamadoId] = useState('');
  const [descricaoOld, setDescricaoOld] = useState('');
  const [descricao, setDescricao] = useState('');
  const [editandoTitulo, setEditandoTitulo] = useState(false);
  const [hoverTitulo, setHoverTitulo] = useState(false);
  const [isMe, setIsMe] = useState(false);
  const [forMe, setForMe] = useState(null);
  const [isChangeEditor, setIsChangeEditor] = useState(null);

  const [dataChamado, setDataChamado] = useState('');

  const [listaUsuariosBackoffice, setListaUsuariosBackoffice] = useState([]);
  const [listaInputsPrioridade, setListaInputsPrioridade] = useState([]);
  const [emCopia, setEmCopia] = useState([]);
  const [actionCompleted, setActionCompleted] = useState(null);
  const [activeTab, setActiveTab] = useState('comments');
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);

  // Chat vinculado (chamado externo)
  const { chatInfo } = useSelector((state) => state.chat);
  const { config } = useSelector((state) => state.global);
  const [chatLoaded, setChatLoaded] = useState(false);
  const [showVincularChat, setShowVincularChat] = useState(false);
  const [chatsDisponiveis, setChatsDisponiveis] = useState([]);
  const [searchChat, setSearchChat] = useState('');
  const [loadingChats, setLoadingChats] = useState(false);

  //comentarios
  const [texto, setTexto] = useState('');
  const [isMediaComentario, setIsMediaComentario] = useState(false);
  const [loadingComentario, setLoadingComentario] = useState(false);
  const [loadingFinalizar, setLoadingFinalizar] = useState(false);
  const [fileSelect, setFileSelect] = useState(null);
  const messagesEnd = useRef(null);
  const [dataConclusao, setDataConclusao] = useState('');
  const emCopiaReduce = emCopia.length > 0 && emCopia.map(item => item._id);
  const validaCopia = emCopia.length > 0 && emCopiaReduce.includes(user.id);

  const buscarUsuarios = async () => {
    try {
      const res = await getActionListaUsuariosByClienteId(user.clienteId);
      setListaUsuariosBackoffice(res.data.usuarios)
    } catch (error) {
      console.log(error)
    }
  }

  const buscarInputsPrioridade = async () => {
    try {
      const res = await actionListaInputsPrioridade(user.clienteId);
      setListaInputsPrioridade(res.data.data)
    } catch (error) {
      console.log(error)
    }
  }

  function validaEdicao() {
    if (!isMe) return true
    if (isMe && !completado) {
      return false
    } else {
      return true
    }
  }

  useEffect(() => {
    buscarUsuarios();
    buscarInputsPrioridade()
    if (chamado) {
      setChamadoId(chamado._id)
      setDescricaoOld(chamado.descricao)
      setDescricao(chamado.descricao);
      setCompletado(chamado.completado);
      setPrioridade(chamado.prioridade)
      setTitulo(chamado.titulo);
      setDataConclusao(chamado.data_para_conclusao ? new Date(chamado.data_para_conclusao) : '');
      setDescricao(chamado.descricao);
      setEmCopia(chamado.copiado_para);
      setDataChamado(chamado)
      setFilesEdit(chamado.arquivos)
      setChecklistLocal(chamado.checklist || [])

      if (user.id === chamado.criado_por) {
        setForMe(false);
        setIsMe(true);
      } else {
        setForMe(true);
        setIsMe(false);
      }
    }

    scrollToBottom();

    return () => {
      setForMe(null)
    }

  }, [chamado, isOpen, isMe]);

  // Carregar chat quando aba "conversa" é selecionada
  useEffect(() => {
    if (activeTab === 'conversa' && chamado?.chat_id && chamado?.chat && !chatLoaded) {
      const chat = chamado.chat;
      dispatch(getChatInfoByChatId(chat._id, chat.funil_id, user.id, true));
      setChatLoaded(true);
    }
  }, [activeTab, chamado, chatLoaded]);

  // Carregar mensagens quando chatInfo estiver pronto com sessao
  useEffect(() => {
    if (activeTab === 'conversa' && chatInfo && chatInfo.sessao && chamado?.chat_id) {
      const chatIdStr = String(chamado.chat?._id || chamado.chat_id);
      const chatInfoIdStr = String(chatInfo._id);
      if (chatIdStr === chatInfoIdStr) {
        dispatch(getMensagensWhatsappDb(chatInfo.sessao, chatInfo.numeroCliente));
      }
    }
  }, [chatInfo?.sessao, chatInfo?._id, activeTab]);

  // Reset chat state quando muda de chamado
  useEffect(() => {
    setChatLoaded(false);
  }, [chamado?._id]);

  const onBuscarChats = async (searchTerm) => {
    setLoadingChats(true);
    try {
      const res = await actionBuscarChatsParaVincular(user.clienteId, searchTerm);
      setChatsDisponiveis(res.data.data || []);
    } catch (error) {
      console.log('Erro ao buscar chats', error);
    }
    setLoadingChats(false);
  };

  const onVincularChat = async (chatId) => {
    try {
      let data = {
        action: 'vincular_chat',
        chat_id: chatId,
        usuarioId: user.id
      };
      await actionEditarChamado(chamado._id, data);
      dispatch(getVerChamado(chamado._id));
      setShowVincularChat(false);
      setSearchChat('');
      setChatsDisponiveis([]);
    } catch (error) {
      console.log('Erro ao vincular chat', error);
    }
  };

  const onDesvincularChat = async () => {
    try {
      let data = {
        action: 'vincular_chat',
        chat_id: null,
        usuarioId: user.id
      };
      await actionEditarChamado(chamado._id, data);
      dispatch(getVerChamado(chamado._id));
      setChatLoaded(false);
    } catch (error) {
      console.log('Erro ao desvincular chat', error);
    }
  };

  const onFecharDetalhesChamado = async () => {
    if (descricao !== descricaoOld) {
      await onEditarDescricao();
      setIsChangeEditor(null);
    }
    onClose();

  }

  const scrollToBottom = () => {
    if (messagesEnd.current) {
      messagesEnd.current.scrollTop = messagesEnd.current.scrollHeight;
    }
  }

  const limparCamposComentarios = () => {
    setLoadingComentario(false);
    setTexto('');
    const filesUrl = []

  }


  const handleKeyUp = (event) => {

    if (!event.shiftKey && event.key === 'Enter') {
      onCriarComentario()
    }
  };

  const onCriarComentario = async () => {
    setLoadingComentario(true)
    try {
      const data = {
        autorId: user.id,
        isMedia: filesUrl.length > 0 ? true : false,
        texto: texto,
        files: filesUrl,
        status: true,
        descontinuado: false
      }
      await actionCriarComentario(chamado._id, data);
      dispatch(getRefreshComments(chamado._id));
      limparCamposComentarios()
    } catch (e) {
      console.log('Erro ao enviar comentário', e)
      setLoadingComentario(false)
    }
  }

  const handleDropMultiFile = useCallback(
    (acceptedFiles) => {
      setFiles(acceptedFiles.map((file) => Object.assign(file, { preview: URL.createObjectURL(file) })));
      let filesSend = acceptedFiles.map((file) => Object.assign(file, { preview: URL.createObjectURL(file) }))
      onEditarArquivosChamados(chamadoId, filesSend);
    },
    [setFiles, chamadoId]
  );

  const handleRemoveAll = () => {
    setFiles([]);
  };

  const handleRemove = (file) => {
    const filteredItems = files.filter((_file) => _file !== file);
    setFiles(filteredItems);
  };




  const handleRemoveEdit = async (file) => {
    setLoadingFinalizar(true);
    const filteredItems = filesEdit.filter((_file) => _file !== file);
    let data = {
      action: 'editar_arquivos',
      arquivos: filteredItems
    }
    await actionEditarChamado(chamado._id, data);
    setFilesEdit(filteredItems);
    setLoadingFinalizar(false);
    setOpenConfirmaExlusaoArquivos(false);
    setFileSelect(null);
  };

  const handleChangeIsFile = (event) => {
    setIsFile(event.target.checked);
  };

  async function uploadAndGetUrl(file) {
    var formData = new FormData();
    var imagefile = file;
    formData.append("file", imagefile);
    try {
      let querys = `?path=chamados/clientes/${user.clienteId}/comentarios`
      const response = await v2_actionUploadS3(formData, querys)
      if (!response.data.error) {
        console.log('!response.data.error')
        filesUrl.push({ key: response.data.data.key, type: file.type, name: file.name, size: file.size })
      }
    } catch (error) {
      console.log('erro ao upload arquivo', error)
    }
  }


  async function uploadFilesAndGetUrl(files) {
    if (files.length > 0) {
      for (let file of files.map(item => item)) {
        var formData = new FormData();
        var imagefile = file;
        formData.append("file", imagefile);
        try {
          let querys = `?path=chamados/clientes/${user.clienteId}/anexos`
          const response = await v2_actionUploadS3(formData, querys)
          if (!response.data.error) {
            console.log('!response.data.error')
            filesUrl.push({ key: response.data.data.key, type: file.type, name: file.name, size: file.size })
          }
        } catch (error) {
          console.log('erro ao upload arquivo', error)
        }
      }
    }
  }


  const onEditarArquivosChamados = async (chamadoId, files) => {
    await uploadFilesAndGetUrl(files);
    let data = {
      action: 'add_arquivos',
      arquivos: filesUrl
    }
    const res = await actionEditarChamado(chamadoId, data);
    if (res) {
      let arquivos = res.data.data.arquivos;
      setFilesEdit(arquivos)
    }
  }


  const [loadingAceitar, setLoadingAceitar] = useState(false);

  const isPendente = chamado && chamado.status === 'pendente' && !completado;
  const needsAccept = isPendente && forMe;

  const onAceitarChamado = async () => {
    setLoadingAceitar(true);
    try {
      await actionEditarChamado(chamado._id, {
        action: 'aceitar_chamado',
        status: 'aberto',
        usuarioId: user.id,
      });
      dispatch(getVerChamado(chamado._id));
      dispatch(getListaTickets({ setorId: user.setorId, usuarioId: user.id, filial: null }));
      dispatch(getListaColunas({ setorId: user.setorId, usuarioId: user.id, filial: '' }));
    } catch (error) {
      console.log('Erro ao aceitar chamado', error);
    }
    setLoadingAceitar(false);
  };

  const handleToggleCompleted = async (action) => {
    setActionCompleted(action);
    setOpenConfirmaFinalizacao(true);

  };

  const onFinalizarChamado = async () => {
    setLoadingFinalizar(true)
    try {
      let data = {
        action: actionCompleted,
        completado: true
      }
      await actionEditarChamado(chamado._id, data);
      dispatch(getVerChamado(chamado._id));
      setOpenConfirmaFinalizacao(false)
      dispatch(getListaTickets({ setorId: user.user.setor_id, usuarioId: user.id, filial: user.user.filial }));
      setLoadingFinalizar(false);
      setActionCompleted(null);
    } catch (error) {
      console.log('error', error);
      setLoadingFinalizar(false);
    }
  };


  const onEditarPrioridade = async (event) => {
    console.log('onEditarPrioridade', event)
    setDataConclusao(event);
    try {
      let data = {
        action: 'editar_estimativa',
        data_para_conclusao: event
      }
      await actionEditarChamado(chamado._id, data);
      dispatch(getVerChamado(chamado._id));
      dispatch(getListaTickets({ setorId: user.setorId, usuarioId: user.id, filial: null }));
    } catch (error) {
      console.log('error', error)
    }
  };

  const onEditarPrioridadeChamado = async (prioridadeId) => {
    try {
      let data = {
        action: 'editar_prioridade',
        prioridade: prioridadeId
      }
      await actionEditarChamado(chamado._id, data);
      dispatch(getVerChamado(chamado._id));
      dispatch(getListaTickets({ setorId: user.setorId, usuarioId: user.id, filial: null }));
    } catch (error) {
      console.log('error', error)
    }
  };

  const onEditarResponsavel = async (usuarioId) => {
    try {
      let data = {
        action: 'editar_responsavel',
        direcionado_para: usuarioId
      }
      await actionEditarChamado(chamado._id, data);
      dispatch(getVerChamado(chamado._id));
      dispatch(getListaTickets({ setorId: user.setorId, usuarioId: user.id, filial: null }));
    } catch (error) {
      console.log('error', error)
    }
  };

  const onEditarTitulo = async () => {
    try {
      let data = {
        action: 'editar_titulo',
        titulo: titulo
      }
      await actionEditarChamado(chamado._id, data);
      dispatch(getVerChamado(chamado._id));
      dispatch(getListaTickets({ setorId: user.setorId, usuarioId: user.id, filial: null }));
    } catch (error) {
      console.log('error', error)
    }
  };

  const onEditarDescricao = async () => {
    try {
      let data = {
        action: 'editar_descricao',
        descricao: descricao
      }
      if (descricao !== descricaoOld) {
        await actionEditarChamado(chamado._id, data);
        dispatch(getVerChamado(chamado._id));
        dispatch(getListaTickets({ setorId: user.setorId, usuarioId: user.id, filial: null }));
      }

    } catch (error) {
      console.log('error', error)
    }
  };

  const onSetarArquivo = async (e) => {
    if (e.target.files.length > 0) {

      let files1 = e.target.files;
      setIsMediaComentario(true)
      await uploadAndGetUrl(e.target.files[0]);
      await onCriarComentario()

    }
  };

  const onEditarCopiadoPara = async (newValue) => {
    let copiadoParaRedeuce = newValue.map(item => item._id);
    setEmCopia(newValue);
    let data = {
      action: 'editar_copiado_para',
      copiadoPara: copiadoParaRedeuce
    }
    try {
      await actionEditarChamado(chamado._id, data);
    } catch (err) {
      console.log('err', err)
    }
  }




  const getUserName = (id) => {
    if (!id || !listaUsuariosBackoffice) return 'Não atribuído';
    const found = listaUsuariosBackoffice.find(u => u._id === id || u.id === id);
    if (!found) return 'Desconhecido';
    return found.nome || found.name || 'Desconhecido';
  }

  const [expandedSections, setExpandedSections] = useState({
    attributes: true,
    copia: true,
    arquivos: false,
    checklist: false,
    chatVinculado: true,
  });

  const [checklistLocal, setChecklistLocal] = useState([]);
  const [newChecklistItem, setNewChecklistItem] = useState('');

  const toggleSection = (section) => {
    setExpandedSections(prev => ({ ...prev, [section]: !prev[section] }));
  };

  const saveChecklist = (updated) => {
    actionEditarChamado(chamado._id, { action: 'editar_checklist', checklist: updated, usuarioId: user.id });
  };

  const handleToggleChecklistItem = (itemId) => {
    const updated = checklistLocal.map(item =>
      item.id === itemId ? { ...item, checked: !item.checked } : item
    );
    setChecklistLocal(updated);
    saveChecklist(updated);
  };

  const handleAddChecklistItem = () => {
    const text = newChecklistItem.trim();
    if (!text) return;
    const newItem = { id: Date.now().toString(), text, checked: false };
    const updated = [...checklistLocal, newItem];
    setChecklistLocal(updated);
    setNewChecklistItem('');
    saveChecklist(updated);
  };

  const handleRemoveChecklistItem = (itemId) => {
    const updated = checklistLocal.filter(item => item.id !== itemId);
    setChecklistLocal(updated);
    saveChecklist(updated);
  };

  const handleChecklistKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddChecklistItem();
    }
  };

  const getStatusLabel = () => {
    if (completado) return 'Finalizado';
    if (chamado && chamado.status === 'pendente') return 'Pendente';
    if (chamado && chamado.status === 'recusado') return 'Recusado';
    return 'Aberto';
  };

  const getStatusStyle = () => {
    if (completado) return 'bg-green-600 text-white';
    if (chamado && chamado.status === 'pendente') return 'bg-amber-500 text-white';
    if (chamado && chamado.status === 'recusado') return 'bg-red-500 text-white';
    return 'bg-blue-600 text-white';
  };

  const renderHeader = () => (
    <TooltipProvider delayDuration={200}>
      <div className="flex flex-col border-b border-gray-100 dark:border-[#383838]/50 sticky top-0 z-10 w-full bg-white dark:bg-[#1A1D21]">
        {/* Row 1 — Title + actions */}
        <div className="flex items-center justify-between px-5 pt-4 pb-2">
          {editandoTitulo && isMe && !completado ? (
            <Input
              autoFocus
              value={titulo}
              onChange={(e) => setTitulo(e.target.value)}
              onBlur={() => {
                onEditarTitulo();
                setEditandoTitulo(false);
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  onEditarTitulo();
                  setEditandoTitulo(false);
                }
              }}
              className="text-[15px] font-bold h-8 flex-1 mr-3 border-gray-200 dark:border-gray-700 focus-visible:ring-1 focus-visible:ring-[#7C3AED]/20 rounded-lg"
              placeholder="Titulo do chamado"
            />
          ) : (
            <div
              className="flex items-center gap-2 flex-1 mr-3"
              onMouseEnter={() => setHoverTitulo(true)}
              onMouseLeave={() => setHoverTitulo(false)}
            >
              <h1
                className={cn(
                  "text-[15px] font-bold text-gray-900 dark:text-gray-100 truncate",
                  isMe && !completado && "cursor-pointer hover:text-[#7C3AED] transition-colors"
                )}
                onClick={() => isMe && !completado && setEditandoTitulo(true)}
              >
                {chamado && chamado.titulo}
              </h1>
              {isMe && !completado && (
                <Iconify
                  icon="eva:edit-2-outline"
                  width={16}
                  className={cn(
                    "text-gray-400 hover:text-[#7C3AED] flex-shrink-0 transition-opacity cursor-pointer",
                    hoverTitulo ? "opacity-100" : "opacity-0"
                  )}
                  onClick={() => setEditandoTitulo(true)}
                />
              )}
            </div>
          )}
          <div className="flex items-center gap-1 flex-shrink-0">
            {/* <Tooltip>
              <TooltipTrigger asChild>
                <button className="w-7 h-7 flex items-center justify-center rounded-md hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-400 transition-colors">
                  <Iconify icon="mdi:star-outline" width={17} />
                </button>
              </TooltipTrigger>
              <TooltipContent side="bottom" className="text-xs">Favoritar</TooltipContent>
            </Tooltip>
            <Tooltip>
              <TooltipTrigger asChild>
                <button className="w-7 h-7 flex items-center justify-center rounded-md hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-400 transition-colors">
                  <Iconify icon="mdi:dots-horizontal" width={17} />
                </button>
              </TooltipTrigger>
              <TooltipContent side="bottom" className="text-xs">Mais opções</TooltipContent>
            </Tooltip>
            <Tooltip>
              <TooltipTrigger asChild>
                <button className="w-7 h-7 flex items-center justify-center rounded-md hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-400 transition-colors">
                  <Iconify icon="mdi:open-in-new" width={16} />
                </button>
              </TooltipTrigger>
              <TooltipContent side="bottom" className="text-xs">Abrir</TooltipContent>
            </Tooltip> */}

            {/* Status badge */}
            <div className={cn(
              "flex items-center gap-1.5 px-3 py-1 rounded-md text-[11px] font-bold flex-shrink-0 ml-1",
              getStatusStyle()
            )}>
              <Iconify
                icon={completado ? "mdi:check-circle" : "mdi:chevron-right"}
                width={13}
              />
              {getStatusLabel()}
            </div>
          </div>
        </div>

      </div>
    </TooltipProvider>
  );

  const renderBody = () => (
    <div className="flex-1 flex flex-col lg:flex-row h-full overflow-hidden w-full bg-transparent gap-2">
      <ModalConfimacao
        open={openConfirmaFinalizacao}
        onClose={() => setOpenConfirmaFinalizacao(false)}
        onConfirm={onFinalizarChamado}
        loadingFinalizar={loadingFinalizar}
        mensagem={'Deseja mesmo finalizar esse chamado'}
      />

      <ModalConfimacao
        open={openConfirmaExlusaoArquivos}
        onClose={() => setOpenConfirmaExlusaoArquivos(false)}
        onConfirm={() => handleRemoveEdit(fileSelect)}
        loadingFinalizar={loadingFinalizar}
        mensagem={'Deseja mesmo excluir esse arquivo?'}
      />

      {/* Center — conversation area (Card 2) */}
      <div className="flex-1 flex flex-col bg-white dark:bg-[#1A1D21] min-h-0 relative rounded-xl overflow-hidden shadow-sm">

        {/* Ticket header — title, metadata, description, actions */}
        {renderHeader()}

        {needsAccept ? (
          /* Tela de aceite — bloqueia acesso ao conteúdo até aceitar */
          <div className="flex-1 flex flex-col items-center justify-center p-8 text-center">
            <div className="w-16 h-16 rounded-2xl bg-amber-50 dark:bg-amber-500/10 flex items-center justify-center mb-5">
              <Iconify icon="mdi:ticket-confirmation-outline" width={32} className="text-amber-500" />
            </div>
            <h3 className="text-[15px] font-bold text-gray-900 dark:text-gray-100 mb-1.5">
              Chamado pendente de aceite
            </h3>
            <p className="text-[13px] text-gray-500 dark:text-gray-400 max-w-sm mb-1">
              Este chamado foi direcionado para você por <span className="font-medium text-gray-700 dark:text-gray-300">{chamado?.nome_autor}</span>.
            </p>
            <p className="text-[13px] text-gray-500 dark:text-gray-400 max-w-sm mb-6">
              Aceite o chamado para visualizar os detalhes e iniciar o atendimento.
            </p>
            <div className="flex items-center gap-3">
              <Button
                variant="ghost"
                className="text-[13px] font-semibold rounded-xl h-10 px-5 text-red-600 hover:text-red-600 hover:bg-red-50 dark:hover:bg-red-500/10"
                onClick={() => handleToggleCompleted('recusar_chamado')}
              >
                <BsFillXOctagonFill className="mr-1.5 h-3.5 w-3.5" />
                Recusar
              </Button>
              <LoadingButton
                className="text-[13px] font-semibold rounded-xl h-10 px-6 bg-[#7C3AED] hover:bg-[#6d28d9] text-white shadow-sm shadow-[#7C3AED]/20"
                loading={loadingAceitar}
                onClick={onAceitarChamado}
              >
                {!loadingAceitar && <CheckCircle2 width={15} height={15} className="mr-1.5" />}
                Aceitar chamado
              </LoadingButton>
            </div>
          </div>
        ) : (
        <>
        {/* Tab bar */}
        <div className="flex items-center bg-white dark:bg-[#1A1D21] flex-shrink-0">
          <Tabs value={activeTab} onValueChange={setActiveTab} className="w-auto">
            <TabsList className="bg-transparent gap-0 p-0 h-auto w-auto mx-4 my-0 inline-flex border-0 shadow-none rounded-none">
              <TabsTrigger
                value="comments"
                className="rounded-none border-b-2 border-transparent text-xs font-medium px-3 py-2.5 data-[state=active]:border-b-gray-900 data-[state=active]:dark:border-b-gray-100 data-[state=active]:bg-transparent data-[state=active]:shadow-none data-[state=active]:text-gray-900 dark:data-[state=active]:text-gray-100 text-gray-500 transition-colors"
              >
                <MessageSquare className="w-3.5 h-3.5 mr-1.5" />
                Comentarios
              </TabsTrigger>
              <TabsTrigger
                value="history"
                className="rounded-none border-b-2 border-transparent text-xs font-medium px-3 py-2.5 data-[state=active]:border-b-gray-900 data-[state=active]:dark:border-b-gray-100 data-[state=active]:bg-transparent data-[state=active]:shadow-none data-[state=active]:text-gray-900 dark:data-[state=active]:text-gray-100 text-gray-500 transition-colors"
              >
                <Clock className="w-3.5 h-3.5 mr-1.5" />
                Historico
              </TabsTrigger>
              {chamado && chamado.tipo === 'externo' && (
                <TabsTrigger
                  value="conversa"
                  className="rounded-none border-b-2 border-transparent text-xs font-medium px-3 py-2.5 data-[state=active]:border-b-gray-900 data-[state=active]:dark:border-b-gray-100 data-[state=active]:bg-transparent data-[state=active]:shadow-none data-[state=active]:text-gray-900 dark:data-[state=active]:text-gray-100 text-gray-500 transition-colors"
                >
                  <MessagesSquare className="w-3.5 h-3.5 mr-1.5" />
                  Conversa
                </TabsTrigger>
              )}
            </TabsList>
          </Tabs>
        </div>

        {/* Content */}
        <Tabs value={activeTab} className="flex-1 flex flex-col min-h-0">
          <TabsContent value="comments" className="mt-0 flex-1 flex flex-col min-h-0 overflow-hidden data-[state=inactive]:hidden">
            <div className="flex-1 overflow-hidden">
              {chamado && (
                <KanbanTaskCommentList
                  chamado={chamado}
                  comments={comentarios}
                />
              )}
            </div>
            <div className="flex-shrink-0 bg-white dark:bg-[#1A1D21] border-t border-gray-100 dark:border-[#383838]">
              <KanbanTaskCommentInput
                completado={completado}
                onFile={onSetarArquivo}
                texto={texto}
                onKeyPress={handleKeyUp}
                loading={loadingComentario}
                changeTexto={e => setTexto(e.target.value)}
                onCriar={onCriarComentario}
              />
            </div>
          </TabsContent>

          <TabsContent value="history" className="mt-0 flex-1 overflow-auto data-[state=inactive]:hidden">
            <div className="p-5">
              <TimelinePadrao data={chamado && chamado.historico} />
            </div>
          </TabsContent>

          {chamado && chamado.tipo === 'externo' && (
            <TabsContent value="conversa" className="mt-0 flex-1 flex flex-col min-h-0 overflow-hidden data-[state=inactive]:hidden">
              {chamado.chat_id && chamado.chat ? (
                <div className="flex-1 flex flex-col min-h-0 overflow-hidden h-full">
                  {chatInfo && chatInfo.sessao ? (
                    <ChatWindow
                      source="chamado.chat"
                      config={config}
                      chatInfo={chatInfo}
                      hideSidebar
                    />
                  ) : (
                    <div className="flex-1 flex items-center justify-center">
                      <div className="flex items-center gap-2 text-[13px] text-gray-500">
                        <div className="w-4 h-4 border-2 border-gray-300 border-t-[#7C3AED] rounded-full animate-spin" />
                        Carregando conversa...
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div className="flex-1 flex flex-col items-center justify-center p-8">
                  <div className="w-16 h-16 rounded-2xl bg-violet-50 dark:bg-violet-500/10 flex items-center justify-center mb-4">
                    <Iconify icon="ic:round-whatsapp" width={32} className="text-violet-500" />
                  </div>
                  <p className="text-[14px] font-medium text-gray-900 dark:text-gray-100 mb-1">Nenhum chat vinculado</p>
                  <p className="text-[12px] text-gray-500 mb-4 text-center">Vincule um chat pelo painel de detalhes ao lado.</p>
                </div>
              )}
            </TabsContent>
          )}

        </Tabs>
        </>
        )}
      </div>

      {/* Right sidebar — Intercom-style details panel (Card 3) */}
      <div className="w-full lg:w-[400px] lg:min-w-[400px] bg-white dark:bg-[#1A1D21] flex-shrink-0 flex flex-col h-full rounded-xl overflow-hidden shadow-sm border-l-[1px] border-l-neutral-200 dark:border-l-[#383838]">
        {/* Details header */}
        <div className="h-[52px] flex items-center px-4 border-b border-gray-100 dark:border-[#383838]/50 flex-shrink-0">
          <span className="text-[14px] font-bold text-gray-900 dark:text-gray-100">Detalhes</span>
        </div>

        {/* Scrollable content */}
        <ScrollArea className="flex-1">
          {/* Sidebar info — label:value inline */}
          <div className="px-4 py-3 space-y-3 border-b border-gray-100 dark:border-[#383838]">
            <div className="flex items-center">
              <span className="text-[12px] text-gray-500 dark:text-gray-400 w-28 flex-shrink-0">Número</span>
              <span className="text-[13px] font-mono font-semibold text-gray-900 dark:text-gray-100">#{chamado && chamado.chamado}</span>
            </div>

            <div className="flex items-center">
              <span className="text-[12px] text-gray-500 dark:text-gray-400 w-28 flex-shrink-0">Solicitante</span>
              <div className="flex items-center gap-2 flex-1 min-w-0">
                <div className="h-5 w-5 rounded-full bg-emerald-600 flex items-center justify-center text-[9px] font-bold text-white uppercase flex-shrink-0">
                  {(chamado?.tipo === 'externo' && chamado?.respondente?.nome
                    ? chamado.respondente.nome
                    : chamado?.nome_autor || getUserName(chamado?.criado_por) || '?'
                  ).charAt(0)}
                </div>
                <span className="text-[13px] font-medium text-gray-900 dark:text-gray-100 truncate">
                  {chamado?.tipo === 'externo' && chamado?.respondente?.nome
                    ? chamado.respondente.nome
                    : chamado?.nome_autor || getUserName(chamado?.criado_por)}
                </span>
              </div>
            </div>

            <div className="flex items-center">
              <span className="text-[12px] text-gray-500 dark:text-gray-400 w-28 flex-shrink-0">Responsável</span>
              <div className="flex-1">
                {!completado ? (
                  <Popover>
                    <PopoverTrigger asChild>
                      <button className="inline-flex items-center gap-2 px-2 py-0.5 rounded-lg cursor-pointer hover:bg-gray-100 dark:hover:bg-neutral-800 transition-colors">
                        <div className="h-5 w-5 rounded-full bg-[#7C3AED] flex items-center justify-center text-[9px] font-bold text-white uppercase flex-shrink-0">
                          {(chamado?.nome_responsavel || getUserName(chamado?.direcionado_para) || '?').charAt(0)}
                        </div>
                        <span className="text-[13px] font-medium text-gray-900 dark:text-gray-100 truncate max-w-[140px]">
                          {chamado?.nome_responsavel || getUserName(chamado?.direcionado_para) || 'Não atribuído'}
                        </span>
                        <ChevronsUpDown className="w-3 h-3 opacity-50" />
                      </button>
                    </PopoverTrigger>
                    <PopoverContent className="w-56 p-0 z-[10000]" align="end">
                      <Command>
                        <CommandInput placeholder="Buscar usuário..." className="h-8 text-xs" />
                        <CommandList className="max-h-[200px]">
                          <CommandEmpty className="text-xs py-2 text-center text-gray-500">Nenhum usuário encontrado.</CommandEmpty>
                          <CommandGroup>
                            {listaUsuariosBackoffice.map((u) => (
                              <CommandItem
                                key={u._id}
                                onSelect={() => onEditarResponsavel(u._id)}
                                className="cursor-pointer flex items-center gap-2"
                              >
                                <Check className={cn('h-3.5 w-3.5', chamado?.direcionado_para === u._id ? 'opacity-100' : 'opacity-0')} />
                                <div className="h-5 w-5 rounded-full bg-violet-100 dark:bg-violet-500/20 flex items-center justify-center text-[9px] font-bold text-violet-600 uppercase flex-shrink-0">
                                  {(u.nomeFantasia || u.nome || '?').charAt(0)}
                                </div>
                                <span className="text-[12px] truncate">{u.nomeFantasia || u.nome}</span>
                              </CommandItem>
                            ))}
                          </CommandGroup>
                        </CommandList>
                      </Command>
                    </PopoverContent>
                  </Popover>
                ) : (
                  <div className="inline-flex items-center gap-2 px-2 py-0.5">
                    <div className="h-5 w-5 rounded-full bg-[#7C3AED] flex items-center justify-center text-[9px] font-bold text-white uppercase flex-shrink-0">
                      {(chamado?.nome_responsavel || getUserName(chamado?.direcionado_para) || '?').charAt(0)}
                    </div>
                    <span className="text-[13px] font-medium text-gray-900 dark:text-gray-100 truncate">
                      {chamado?.nome_responsavel || getUserName(chamado?.direcionado_para) || 'Não atribuído'}
                    </span>
                  </div>
                )}
              </div>
            </div>

            {chamado && chamado.tipo === 'externo' && (
              <div className="flex items-center">
                <span className="text-[12px] text-gray-500 dark:text-gray-400 w-28 flex-shrink-0">Visibilidade</span>
                <span className="text-[13px] text-gray-900 dark:text-gray-100">Compartilhado com o cliente</span>
              </div>
            )}

   
          </div>

          {/* Action buttons */}
          {!completado && !validaCopia && (
            <div className="flex items-center gap-2 px-4 py-3 border-b border-gray-100 dark:border-[#383838]">
              {forMe && (
                <Button
                  size="sm"
                  variant="ghost"
                  className="text-[12px] font-semibold rounded-lg h-[28px] px-2.5 text-red-600 hover:text-red-600 hover:bg-red-50 dark:hover:bg-red-500/10 transition-colors"
                  onClick={() => handleToggleCompleted('recusar_chamado')}
                >
                  <BsFillXOctagonFill className="mr-1 h-3 w-3" />
                  Recusar
                </Button>
              )}
              {!forMe && (
                <Button
                  size="sm"
                  variant="ghost"
                  className="text-[12px] font-semibold rounded-lg h-[28px] px-2.5 text-red-600 hover:text-red-600 hover:bg-red-50 dark:hover:bg-red-500/10 transition-colors"
                  onClick={() => handleToggleCompleted('cancelar_chamado')}
                >
                  <BsFillXOctagonFill className="mr-1 h-3 w-3" />
                  Cancelar
                </Button>
              )}
              <LoadingButton
                size="sm"
                className="text-[12px] font-semibold rounded-lg h-[28px] px-3 bg-[#7C3AED] hover:bg-[#6d28d9] text-white border-0 shadow-sm shadow-[#7C3AED]/20 transition-colors"
                loading={loadingFinalizar}
                onClick={() => handleToggleCompleted('editar_completado')}
              >
                {!loadingFinalizar && <CheckCircle2 width={13} height={13} className="mr-1" />}
                Finalizar
              </LoadingButton>
            </div>
          )}

          {/* Ticket Attributes — collapsible */}
          <div className="border-b border-gray-100 dark:border-[#383838]">
            <button
              onClick={() => toggleSection('attributes')}
              className="w-full flex items-center justify-between px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors"
            >
              <div className="flex items-center gap-2">
                <Iconify icon="mdi:ticket-outline" width={15} className="text-gray-400" />
                <span className="text-[13px] font-semibold text-gray-900 dark:text-gray-100">Atributos do chamado</span>
              </div>
              <Iconify
                icon={expandedSections.attributes ? "mdi:chevron-up" : "mdi:chevron-down"}
                width={16}
                className="text-gray-400"
              />
            </button>

            {expandedSections.attributes && (
              <div className="px-4 pb-3 space-y-3 animate-in fade-in slide-in-from-top-1 duration-200">
                {/* Status */}
                <div className="flex items-center justify-between">
                  <span className="text-[12px] text-gray-500 dark:text-gray-400 w-28 flex-shrink-0">Status</span>
                  <div className="flex-1">
                    <div className={cn(
                      "inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-semibold",
                      completado
                        ? "text-green-700 bg-green-50 dark:bg-green-500/10 dark:text-green-400"
                        : chamado && chamado.status === 'pendente'
                          ? "text-amber-700 bg-amber-50 dark:bg-amber-500/10 dark:text-amber-400"
                          : "text-violet-700 bg-violet-50 dark:bg-violet-500/10 dark:text-violet-400"
                    )}>
                      <div className={cn("w-1.5 h-1.5 rounded-full",
                        completado ? "bg-green-500" : chamado && chamado.status === 'pendente' ? "bg-amber-500" : "bg-violet-600"
                      )} />
                      {completado ? "Finalizado" : chamado && chamado.status === 'pendente' ? 'Pendente' : "Em Progresso"}
                    </div>
                  </div>
                </div>

                {/* Priority */}
                <div className="flex items-center justify-between">
                  <span className="text-[12px] text-gray-500 dark:text-gray-400 w-28 flex-shrink-0">Prioridade</span>
                  <div className="flex-1">
                    {!completado ? (
                      <Popover>
                        <PopoverTrigger asChild>
                          <button className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-semibold uppercase cursor-pointer hover:opacity-80 transition-opacity"
                            style={{
                              backgroundColor: chamado?.prioridade_cor ? `${chamado.prioridade_cor}15` : '#f3f4f6',
                              color: chamado?.prioridade_cor || '#9ca3af'
                            }}
                          >
                            {chamado?.prioridade_titulo ? (
                              <>
                                <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: chamado.prioridade_cor }} />
                                {chamado.prioridade_titulo}
                              </>
                            ) : (
                              <span className="text-gray-400 normal-case font-normal italic">Selecionar</span>
                            )}
                            <ChevronsUpDown className="w-3 h-3 ml-0.5 opacity-50" />
                          </button>
                        </PopoverTrigger>
                        <PopoverContent className="w-48 p-0 z-[10000]" align="end">
                          <Command>
                            <CommandList>
                              <CommandGroup>
                                {listaInputsPrioridade.filter(p => p.ativo !== false).map((prio) => (
                                  <CommandItem
                                    key={prio._id}
                                    onSelect={() => onEditarPrioridadeChamado(prio._id)}
                                    className="cursor-pointer flex items-center gap-2"
                                  >
                                    <Check className={cn('h-3.5 w-3.5', chamado?.prioridade === prio._id ? 'opacity-100' : 'opacity-0')} />
                                    <span className="w-2 h-2 rounded-full flex-shrink-0" style={{ backgroundColor: prio.cor }} />
                                    <span className="text-[12px]">{prio.titulo}</span>
                                  </CommandItem>
                                ))}
                              </CommandGroup>
                            </CommandList>
                          </Command>
                        </PopoverContent>
                      </Popover>
                    ) : (
                      chamado?.prioridade_titulo ? (
                        <div className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-semibold uppercase"
                          style={{ backgroundColor: chamado.prioridade_cor ? `${chamado.prioridade_cor}15` : undefined, color: chamado.prioridade_cor || undefined }}
                        >
                          <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: chamado.prioridade_cor }} />
                          {chamado.prioridade_titulo}
                        </div>
                      ) : (
                        <span className="text-[13px] text-gray-400 dark:text-gray-500 italic">Nao definida</span>
                      )
                    )}
                  </div>
                </div>

                {/* Tipo */}
                <div className="flex items-center justify-between">
                  <span className="text-[12px] text-gray-500 dark:text-gray-400 w-28 flex-shrink-0">Tipo</span>
                  <span className="text-[13px] text-gray-900 dark:text-gray-100">
                    {chamado && chamado.tipo === 'externo' ? 'Externo' : 'Interno'}
                  </span>
                </div>

                {/* Caixa de Entrada (chamados externos) */}
                {chamado && chamado.tipo === 'externo' && chamado.caixa_entrada_nome && (
                  <div className="flex items-center justify-between">
                    <span className="text-[12px] text-gray-500 dark:text-gray-400 w-28 flex-shrink-0">Caixa de Entrada</span>
                    <div className="flex items-center gap-1.5">
                      <Iconify icon="eva:inbox-outline" width={14} className="text-orange-500" />
                      <span className="text-[13px] text-gray-900 dark:text-gray-100">{chamado.caixa_entrada_nome}</span>
                    </div>
                  </div>
                )}

                {/* Data de criação */}
                <div className="flex items-center justify-between">
                  <span className="text-[12px] text-gray-500 dark:text-gray-400 w-28 flex-shrink-0">Criado em</span>
                  <span className="text-[13px] text-gray-900 dark:text-gray-100">
                    {chamado && chamado.data_criacao && format(new Date(chamado.data_criacao), "dd MMM yyyy", { locale: ptBR })}
                  </span>
                </div>

                {/* Prazo */}
                <div className="flex items-center justify-between">
                  <span className="text-[12px] text-gray-500 dark:text-gray-400 w-28 flex-shrink-0">Prazo</span>
                  {!completado ? (
                    <div className="flex-1 flex justify-end">
                      <DateTimePicker
                        value={dataConclusao}
                        onChange={onEditarPrioridade}
                        disabled={completado}
                      />
                    </div>
                  ) : (
                    <span className="text-[13px] text-gray-900 dark:text-gray-100">
                      {chamado && chamado.data_para_conclusao
                        ? format(new Date(chamado.data_para_conclusao), "dd MMM yyyy, HH:mm", { locale: ptBR })
                        : <span className="text-gray-400">—</span>
                      }
                    </span>
                  )}
                </div>

                {/* Respostas do formulário (chamados externos) */}
                {chamado?.respostas_formulario?.length > 0 && (
                  <>
      
                    {chamado.respostas_formulario.map((resposta) => (
                      <div key={resposta._id || resposta.campo_id} className="flex items-center justify-between">
                        <span className="text-[12px] text-gray-500 dark:text-gray-400 w-28 flex-shrink-0 truncate" title={resposta.campo_titulo}>
                          {resposta.campo_titulo}
                        </span>
                        <span className="text-[13px] text-gray-900 dark:text-gray-100 truncate text-right flex-1" title={resposta.valor}>
                          {resposta.valor || <span className="text-gray-400">—</span>}
                        </span>
                      </div>
                    ))}
                  </>
                )}
              </div>
            )}
          </div>

          {/* Description — collapsible */}
          <div className="border-b border-gray-100 dark:border-[#383838]">
            <button
              onClick={() => setIsDescriptionExpanded(!isDescriptionExpanded)}
              className="w-full flex items-center justify-between px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors"
            >
              <div className="flex items-center gap-2">
                <FileText className="w-[15px] h-[15px] text-gray-400" />
                <span className="text-[13px] font-semibold text-gray-900 dark:text-gray-100">Descricao</span>
              </div>
              <Iconify
                icon={isDescriptionExpanded ? "mdi:chevron-up" : "mdi:chevron-down"}
                width={16}
                className="text-gray-400"
              />
            </button>

            {isDescriptionExpanded && (
              <div className="px-4 pb-3 animate-in fade-in slide-in-from-top-1 duration-200">
                {isMe && !completado ? (
                  <Textarea
                    value={descricao}
                    onChange={(e) => setDescricao(e.target.value)}
                    onBlur={onEditarDescricao}
                    className="min-h-[80px] text-[13px] text-gray-900 dark:text-gray-100 leading-relaxed p-3 border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 focus:border-[#7C3AED] focus-visible:ring-1 focus-visible:ring-[#7C3AED]/20 rounded-lg transition-colors resize-none shadow-none"
                    placeholder="Adicione uma descricao detalhada..."
                  />
                ) : (
                  <div className="text-[13px] text-gray-700 dark:text-gray-300 leading-relaxed whitespace-pre-wrap">
                    <Markdown children={descricao || "_Nenhuma descricao fornecida._"} />
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Em Cópia — collapsible */}
          <div className="border-b border-gray-100 dark:border-[#383838]">
            <button
              onClick={() => toggleSection('copia')}
              className="w-full flex items-center justify-between px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors"
            >
              <div className="flex items-center gap-2">
                <User className="w-[15px] h-[15px] text-gray-400" />
                <span className="text-[13px] font-semibold text-gray-900 dark:text-gray-100">Em Copia</span>
                {emCopia && emCopia.length > 0 && (
                  <Badge variant="secondary" className="h-4 min-w-[18px] px-1 text-[10px] font-bold bg-violet-100 dark:bg-violet-500/15 text-violet-700 dark:text-violet-400">
                    {emCopia.length}
                  </Badge>
                )}
              </div>
              <Iconify
                icon={expandedSections.copia ? "mdi:chevron-up" : "mdi:chevron-down"}
                width={16}
                className="text-gray-400"
              />
            </button>

            {expandedSections.copia && (
              <div className="px-4 pb-3 animate-in fade-in slide-in-from-top-1 duration-200">
                <Combobox
                  multiple
                  options={listaUsuariosBackoffice}
                  getOptionLabel={(option) => option.nomeFantasia || option.nome || option.name || ''}
                  value={emCopia ? emCopia.map(item => {
                    if (typeof item !== 'object') {
                      return listaUsuariosBackoffice.find(u => u._id === item || u.id === item) || item;
                    }
                    return item;
                  }).filter(item => typeof item === 'object') : []}
                  onChange={onEditarCopiadoPara}
                  onOpen={() => buscarUsuarios()}
                  placeholder="+ Adicionar pessoas"
                  className="bg-gray-50 dark:bg-gray-800 border-gray-200 dark:border-gray-700 hover:border-gray-300 h-8 text-[12px] w-full rounded-lg shadow-none"
                />
                {emCopia && emCopia.length > 0 && (
                  <div className="flex flex-wrap gap-1.5 mt-2.5">
                    {emCopia.map((u, i) => {
                      const userObj = typeof u === 'object' ? u : listaUsuariosBackoffice.find(user => user._id === u || user.id === u);
                      if (!userObj) return null;
                      const displayName = userObj.nomeFantasia || userObj.nome || userObj.name || '?';
                      return (
                        <div key={i} className="flex items-center gap-1.5 px-2 py-0.5 rounded-full bg-gray-100 dark:bg-gray-800 text-[11px] text-gray-700 dark:text-gray-300">
                          <div className="h-4 w-4 rounded-full bg-[#7C3AED] flex items-center justify-center text-[8px] font-bold text-white uppercase flex-shrink-0">
                            {displayName.charAt(0)}
                          </div>
                          {displayName}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Attachments — collapsible */}
          <div className="border-b border-gray-100 dark:border-[#383838]">
            <button
              onClick={() => toggleSection('arquivos')}
              className="w-full flex items-center justify-between px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors"
            >
              <div className="flex items-center gap-2">
                <Paperclip className="w-[15px] h-[15px] text-gray-400" />
                <span className="text-[13px] font-semibold text-gray-900 dark:text-gray-100">Arquivos</span>
                {filesEdit && filesEdit.length > 0 && (
                  <Badge variant="secondary" className="h-4 min-w-[18px] px-1 text-[10px] font-bold bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400">
                    {filesEdit.length}
                  </Badge>
                )}
              </div>
              <Iconify
                icon={expandedSections.arquivos ? "mdi:chevron-up" : "mdi:chevron-down"}
                width={16}
                className="text-gray-400"
              />
            </button>

            {expandedSections.arquivos && (
              <div className="px-4 pb-3 animate-in fade-in slide-in-from-top-1 duration-200">
                <ChamadosArquivos
                  isMe={isMe}
                  loadingEnviarArquivos={loadingEnviarArquivos}
                  showPreview={preview}
                  completado={completado}
                  files={files}
                  isEdit={isEdit}
                  isEditFile={isEditFile}
                  filesEdit={filesEdit}
                  onRemoveEdit={(file) => {
                    setFileSelect(file);
                    setOpenConfirmaExlusaoArquivos(true);
                  }}
                  onDrop={handleDropMultiFile}
                  onRemove={handleRemove}
                  attachments={attachments}
                />
              </div>
            )}
          </div>

          {/* Checklist — collapsible */}
          <div className="border-b border-gray-100 dark:border-[#383838]">
            <button
              onClick={() => toggleSection('checklist')}
              className="w-full flex items-center justify-between px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors"
            >
              <div className="flex items-center gap-2">
                <Iconify icon="mdi:checkbox-marked-outline" width={15} className="text-gray-400" />
                <span className="text-[13px] font-semibold text-gray-900 dark:text-gray-100">Checklist</span>
                {checklistLocal.length > 0 && (
                  <Badge variant="secondary" className="h-4 min-w-[18px] px-1 text-[10px] font-bold bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400">
                    {checklistLocal.filter(i => i.checked).length}/{checklistLocal.length}
                  </Badge>
                )}
              </div>
              <Iconify
                icon={expandedSections.checklist ? "mdi:chevron-up" : "mdi:chevron-down"}
                width={16}
                className="text-gray-400"
              />
            </button>

            {expandedSections.checklist && (
              <div className="px-4 pb-3 animate-in fade-in slide-in-from-top-1 duration-200">
                {/* Progress bar */}
                {checklistLocal.length > 0 && (() => {
                  const checked = checklistLocal.filter(i => i.checked).length;
                  const total = checklistLocal.length;
                  const pct = Math.round((checked / total) * 100);
                  const isComplete = pct === 100;
                  return (
                    <div className="mb-3">
                      <div className="flex items-center justify-between mb-1">
                        <span className="text-[11px] text-gray-500">{pct}%</span>
                        <span className="text-[11px] text-gray-400">{checked}/{total}</span>
                      </div>
                      <div className="w-full h-1.5 bg-gray-100 dark:bg-gray-700 rounded-full overflow-hidden">
                        <div
                          className={`h-full rounded-full transition-all duration-300 ${isComplete ? 'bg-green-500' : 'bg-violet-500'}`}
                          style={{ width: `${pct}%` }}
                        />
                      </div>
                    </div>
                  );
                })()}

                {/* Checklist items */}
                <div className="space-y-1">
                  {checklistLocal.map(item => (
                    <div key={item.id} className="group flex items-center gap-2 py-1.5 px-2 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors">
                      <Checkbox
                        checked={item.checked}
                        onCheckedChange={() => handleToggleChecklistItem(item.id)}
                        className="data-[state=checked]:bg-violet-600 data-[state=checked]:border-violet-600"
                      />
                      <span className={cn(
                        "flex-1 text-[13px] text-gray-700 dark:text-gray-300",
                        item.checked && "line-through text-gray-400 dark:text-gray-500"
                      )}>
                        {item.text}
                      </span>
                      <button
                        onClick={() => handleRemoveChecklistItem(item.id)}
                        className="opacity-0 group-hover:opacity-100 p-1 rounded-md hover:bg-red-50 dark:hover:bg-red-500/10 text-gray-400 hover:text-red-500 transition-all"
                      >
                        <Trash2 className="w-3.5 h-3.5" />
                      </button>
                    </div>
                  ))}
                </div>

                {/* Add new item */}
                <div className="flex items-center gap-2 mt-2">
                  <Input
                    value={newChecklistItem}
                    onChange={(e) => setNewChecklistItem(e.target.value)}
                    onKeyDown={handleChecklistKeyDown}
                    placeholder="Adicionar item..."
                    className="h-8 text-[13px] rounded-lg border-gray-200 dark:border-gray-700 focus:border-violet-500 dark:focus:border-violet-500"
                  />
                  <button
                    onClick={handleAddChecklistItem}
                    disabled={!newChecklistItem.trim()}
                    className="p-1.5 rounded-lg bg-violet-50 dark:bg-violet-500/10 text-violet-600 dark:text-violet-400 hover:bg-violet-100 dark:hover:bg-violet-500/20 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
                  >
                    <Plus className="w-4 h-4" />
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* Chat Vinculado — collapsible (apenas chamados externos) */}
          {chamado && chamado.tipo === 'externo' && (
            <div className="border-b border-gray-100 dark:border-[#383838]">
              <button
                onClick={() => toggleSection('chatVinculado')}
                className="w-full flex items-center justify-between px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors"
              >
                <div className="flex items-center gap-2">
                  <Iconify icon="ic:round-whatsapp" width={15} className="text-gray-400" />
                  <span className="text-[13px] font-semibold text-gray-900 dark:text-gray-100">Chat Vinculado</span>
                  {chamado.chat_id && chamado.chat && (
                    <span className="w-1.5 h-1.5 rounded-full bg-green-500" />
                  )}
                </div>
                <Iconify
                  icon={expandedSections.chatVinculado ? "mdi:chevron-up" : "mdi:chevron-down"}
                  width={16}
                  className="text-gray-400"
                />
              </button>

              {expandedSections.chatVinculado && (
                <div className="px-4 pb-3 animate-in fade-in slide-in-from-top-1 duration-200">
                  {chamado.chat_id && chamado.chat ? (
                    <div className="space-y-2.5">
                      {/* Chat info card */}
                      <div className="flex items-center gap-2.5 p-2.5 rounded-lg bg-gray-50 dark:bg-gray-800/50 border border-gray-100 dark:border-[#383838]">
                        <div className="w-9 h-9 rounded-full bg-green-100 dark:bg-green-500/15 flex items-center justify-center flex-shrink-0">
                          <Iconify icon="ic:round-whatsapp" width={18} className="text-green-600 dark:text-green-400" />
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="text-[13px] font-medium text-gray-900 dark:text-gray-100 truncate">
                            {chamado.chat?.nomeCliente || 'Sem nome'}
                          </p>
                          <p className="text-[11px] text-gray-500 truncate">
                            {chamado.chat?.numeroCliente}
                          </p>
                        </div>
                      </div>

                      {/* Actions */}
                      <div className="flex items-center gap-2">
                        <button
                          className="flex-1 flex items-center justify-center gap-1.5 px-3 py-1.5 rounded-lg text-[12px] font-medium text-[#7C3AED] bg-violet-50 dark:bg-violet-500/10 hover:bg-violet-100 dark:hover:bg-violet-500/20 transition-colors"
                          onClick={() => setActiveTab('conversa')}
                        >
                          <MessagesSquare className="w-3.5 h-3.5" />
                          Ver conversa
                        </button>
                        <button
                          className="flex items-center justify-center gap-1 px-3 py-1.5 rounded-lg text-[12px] font-medium text-red-500 bg-red-50 dark:bg-red-500/10 hover:bg-red-100 dark:hover:bg-red-500/20 transition-colors"
                          onClick={onDesvincularChat}
                        >
                          <Iconify icon="eva:close-circle-outline" width={14} />
                          Desvincular
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="space-y-2.5">
                      <p className="text-[12px] text-gray-500">Nenhum chat vinculado a este chamado.</p>

                      {!showVincularChat ? (
                        <button
                          className="w-full flex items-center justify-center gap-1.5 px-3 py-2 rounded-lg text-[12px] font-medium text-[#7C3AED] bg-violet-50 dark:bg-violet-500/10 hover:bg-violet-100 dark:hover:bg-violet-500/20 border border-violet-200 dark:border-violet-500/20 transition-colors"
                          onClick={() => {
                            setShowVincularChat(true);
                            onBuscarChats('');
                          }}
                        >
                          <Iconify icon="eva:link-2-outline" width={14} />
                          Vincular Chat
                        </button>
                      ) : (
                        <div className="space-y-2">
                          <div className="relative">
                            <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400" />
                            <Input
                              placeholder="Buscar por nome ou numero..."
                              className="pl-8 h-8 text-[12px] rounded-lg border-gray-200 dark:border-[#383838] focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 shadow-none"
                              value={searchChat}
                              onChange={(e) => {
                                setSearchChat(e.target.value);
                                onBuscarChats(e.target.value);
                              }}
                            />
                          </div>
                          <div className="max-h-[200px] overflow-auto space-y-0.5 border border-gray-100 dark:border-[#383838] rounded-lg p-1.5">
                            {loadingChats ? (
                              <div className="text-center py-3 text-[11px] text-gray-500">Buscando...</div>
                            ) : chatsDisponiveis.length === 0 ? (
                              <div className="text-center py-3 text-[11px] text-gray-500">Nenhum chat encontrado</div>
                            ) : (
                              chatsDisponiveis.map((chat) => (
                                <button
                                  key={chat._id}
                                  className="w-full flex items-center gap-2 p-2 rounded-md hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors text-left"
                                  onClick={() => onVincularChat(chat._id)}
                                >
                                  <div className="w-7 h-7 rounded-full bg-green-100 dark:bg-green-500/15 flex items-center justify-center flex-shrink-0">
                                    <Iconify icon="ic:round-whatsapp" width={14} className="text-green-600 dark:text-green-400" />
                                  </div>
                                  <div className="flex-1 min-w-0">
                                    <p className="text-[12px] font-medium text-gray-900 dark:text-gray-100 truncate">
                                      {chat.nomeCliente || 'Sem nome'}
                                    </p>
                                    <p className="text-[10px] text-gray-500 truncate">
                                      {chat.numeroCliente}
                                    </p>
                                  </div>
                                </button>
                              ))
                            )}
                          </div>
                          <button
                            className="w-full text-center text-[11px] text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 py-1 transition-colors"
                            onClick={() => {
                              setShowVincularChat(false);
                              setSearchChat('');
                              setChatsDisponiveis([]);
                            }}
                          >
                            Cancelar
                          </button>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </ScrollArea>
      </div>
    </div>
  );

  if (!isDialog) {
    return (
      <div className="flex-1 h-full w-full bg-transparent">
        {renderBody()}
      </div>
    );
  }

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onFecharDetalhesChamado()}>
      <DialogContent className="max-w-[90vw] w-[1200px] h-[90vh] p-2 flex flex-col rounded-2xl overflow-hidden border border-gray-200/50 dark:border-gray-700/50 bg-[#F0F0F0] dark:bg-[#111214] shadow-2xl [&>button]:top-3 [&>button]:right-3 [&>button]:z-50 [&>button]:text-gray-500 [&>button]:hover:text-gray-900 [&>button]:hover:bg-gray-100 [&>button]:dark:text-gray-400 [&>button]:dark:hover:text-gray-100 [&>button]:dark:hover:bg-gray-800 [&>button]:rounded-lg [&>button]:h-7 [&>button]:w-7">
        <DialogHeader className="p-0 m-0 border-b-0 space-y-0 sr-only">
          <DialogTitle>Chamado</DialogTitle>
        </DialogHeader>
        {renderBody()}
      </DialogContent>
    </Dialog>
  );
}
